<template>
  <div>
    <div class="mobile-input">
      <my-input
        :tipText="mobileTip"
        :text="mobile"
        :isError="mobileIsError"
        :maxLength="mobileMaxLength"
        @tipClick="mobileClick"
        @blurEvent="checkMobile"
        @on-change="mobileChange"
        :inputType="inputType"
      ></my-input>
      <span
        class="checkCode-btn"
        :class="btnState"
        v-show="mobileRight"
        @click="getCheckCode('')"
      >{{getCheckCodeText}}</span>
    </div>
    <div class="checkCode-input" v-show="showCheckCode">
      <my-input
        :tipText="checkCodeTip"
        :text="checkCode"
        :isError="checkCodeIsError"
        :maxLength="checkCodeMaxLength"
        @tipClick="checkCodeClick"
        @blurEvent="verifyCheckCode"
        :isFocusing="focusCheckCode"
        :inputType="inputType"
      ></my-input>
      <i class="checkCode-right" v-show="checkCodeState"></i>
    </div>
    <img-code v-if="showImgCodeBox" @getCheckCode="getCheckCode" @closeImgBox="closeImgBox"></img-code>
  </div>
</template>
<script>
import * as types from "../../../store/mutation-types";
import config from "../../../util/config";
import login from "../../../util/login";
import cookie from "../../../util/cookie";
import myInput from "../../common/myInput";
import imgCode from "./imgCode";
import { mapGetters } from "vuex";

export default {
  components: {
    myInput,
    imgCode
  },
  data() {
    return {
      imgCodeUrl: "",
      showImgCodeBox: false,
      mobileLogin: undefined,

      inputType: "tel", // 输入框类型，默认展示数字键
      mobileTip: "输入手机号", // 手机号框
      mobile: "",
      mobileIsError: false,
      mobileMaxLength: 11,

      checkCodeTip: "请输入6位验证码", // 验证码框
      checkCode: "",
      checkCodeIsError: false,
      checkCodeMaxLength: 6,
      focusCheckCode: false,

      mobileRight: false, // 手机号是否正确
      getCheckCodeText: "获取验证码",
      btnState: "",
      showCheckCode: false, // 是否展示验证码框
      checkCodeState: false, // 验证码状态
      isIOS: navigator.userAgent.match(/iphone/i)
    };
  },
  computed: {
    ...mapGetters(["pagetypeLog", "pagefrom"])
  },
  methods: {
    // 手机号项点击
    mobileClick(value) {
      if (value === "") {
        this.mobileIsError = false;
        this.mobileTip = "请输入11位手机号码";
      }
      window.clickLog &&
        window.clickLog("from=jl_phonenumclk_nologin" + this.pagetypeLog);
    },

    // 手机号由正确状态改为错误状态时，隐藏获取验证码按钮
    mobileChange(mobile) {
      if (mobile.length < 11) {
        this.mobileRight = false;
      }
    },

    // 检查手机号
    checkMobile(value) {
      // 检查前默认将手机号填写状态置为false
      this.$store.commit(types.CHECK_BASICINFO, {
        key: "mobile",
        value: value,
        state: false
      });
      if (value === "") {
        this.mobileIsError = true;
        this.mobileRight = false;
        this.mobileTip = "输入手机号";
        window.clickLog &&
          window.clickLog("from=jl_phonenum_wrong" + this.pagetypeLog);
      } else if (!config.mobileReg.test(value)) {
        this.mobileIsError = true;
        this.mobileRight = false;
        this.mobileTip = "手机号码格式不对";
        window.clickLog &&
          window.clickLog("from=jl_phonenum_wrong" + this.pagetypeLog);
      } else {
        // 百度小程序、头条小程序设置手机号认证通过
        if (this.pagefrom == "fromBD" || this.pagefrom == "fromTT") {
          this.$store.commit(types.CHECK_BASICINFO, {
            key: "mobile",
            value: value,
            state: true
          });
        }
        // 如果手机号输入达11位且正确，则进行检查认证
        this.mobileIsError = false;
        this.mobileRight = true;
        this.mobileTip = "手机号";
        this.mobile = value;
      }
    },

    // 验证码点击
    checkCodeClick(value) {
      if (value === "") {
        this.checkCodeIsError = false;
        this.checkCodeTip = "请输入6位验证码";
      }
    },

    // 校验验证码
    verifyCheckCode(value) {
      // 检查前默认将手机号填写状态置为false
      this.$store.commit(types.CHECK_BASICINFO, {
        key: "keyCode",
        value: value,
        state: false
      });
      if (value === "") {
        this.checkCodeIsError = true;
        this.checkCodeTip = "输入验证码";
        window.clickLog &&
          window.clickLog("from=jl_numcode_wrong" + this.pagetypeLog);
      } else if (value.length < 6) {
        this.checkCodeState = false;
        this.checkCodeIsError = true;
        this.checkCodeTip = "请输入6位验证码";
        window.clickLog &&
          window.clickLog("from=jl_numcode_wrong" + this.pagetypeLog);
      } else {
        //fix: 临时解决登录SDK和头条SDK冲问题
        //TODO: 推动登录SDK兼容eval被重置问题
        if (this.pagefrom == "fromTT" && !window.eval) {
          window.eval = function() {};
        }

        login
          .loginCommit(this.mobile, value)
          .then(res => {
            // 登录成功,展示为手机号展示框
            if (res.code === 0) {
              // 获取该账号下的简历份数
              this.$store.dispatch(
                "getResumeCount",
                cookie.getname("PPU", "UID")
              );

              // 更改提交的手机号
              this.$store.commit(types.CHECK_BASICINFO, {
                key: "mobile",
                value: this.mobile,
                state: true
              });

              // 更改提交的验证码号
              this.$store.commit(types.CHECK_BASICINFO, {
                key: "keyCode",
                value: this.checkCode,
                state: true
              });

              // 更改认证状态
              this.$store.commit(types.CHANGE_HASAUTHED, {
                auth: true,
                authMobile: this.mobile
              });

              // 存储登录使用的手机号
              this.$store.commit(types.SET_HASAUTHEDMOBILE, this.mobile);

              // 更改登录状态
              this.$store.commit(types.CHANGE_LOGINSTATE, true);

              window.clickLog &&
                window.clickLog("from=jl_numcode_right" + this.pagetypeLog);
            } else {
              this.checkCodeIsError = true;
              this.checkCodeTip = "验证码输入错误";
              window.clickLog &&
                window.clickLog("from=jl_numcode_wrong" + this.pagetypeLog);
            }
          })
          .catch(e => {
            this.checkCodeIsError = true;
            this.checkCodeTip = "验证码输入错误";
            console.log(e);
          });
      }
    },

    // 获取手机验证码点击事件
    getCheckCode(imgCode = "") {
      if (this.btnState === "") {
        // 当imgcode为空时为获取按钮点击
        if (imgCode === "") {
          window.clickLog &&
            window.clickLog("from=jl_phonecode_btn" + this.pagetypeLog);
        }
        login.getAuthCode(this.mobile, imgCode).then(res => {
          // 发送成功
          if (res.code === 0) {
            this.showImgCodeBox = false;
            this.btnState = "disabled";
            this.countDown();
            this.showCheckCode = true;

            // 非ios时将焦点置于验证码框，ios不进行焦点转移
            if (this.isIOS) {
              this.checkCodeTip = "输入验证码";
            } else {
              this.focusCheckCode = true;
            }

            window.clickLog &&
              window.clickLog("from=jl_numcode_show" + this.pagetypeLog);
            // 图片验证码正确（未登录态）
            if (imgCode !== "") {
              window.clickLog &&
                window.clickLog("from=jl_tupiancode_right" + this.pagetypeLog);
            }
          } else if (res.code === 785 || res.code === 786) {
            // 图片验证码报错（未登录态）
            if (imgCode === "") {
              window.clickLog &&
                window.clickLog("from=jl_tupiancode_show" + this.pagetypeLog);
            } else {
              window.clickLog &&
                window.clickLog("from=jl_tupiancode_wrong" + this.pagetypeLog);
            }
            this.showImgCodeBox = true;
          } else {
            // 提示错误信息
            this.mobileTip = res.msg;
            this.mobileIsError = true;
          }
        });
      }
    },

    // 关闭图片验证码框
    closeImgBox() {
      this.showImgCodeBox = false;
    },

    // 按钮倒计时
    countDown(wait = 60) {
      if (wait === 0) {
        this.getCheckCodeText = "重新获取";
        this.btnState = "";
      } else {
        this.getCheckCodeText = "已发送" + wait + "s";
        wait--;
        setTimeout(() => {
          this.countDown(wait);
        }, 1000);
      }
    },

    // 点击保存检查为空
    checkNull() {
      this.checkMobile("");
    }
  }
};
</script>
<style lang="scss" scoped>
@import "../../../assets/style/public.scss";

.mobile-input,
.checkCode-input {
  width: 100%;
  position: relative;
}

.input-tip {
  margin-top: 0;
}

.checkCode-btn {
  display: inline-block;
  position: absolute;
  top: px2rem(56px);
  right: px2rem(64px);
  height: px2rem(60px);
  line-height: px2rem(58px);
  padding: 0 px2rem(20px);
  border: 1px solid $orange;
  border-radius: px2rem(124px);
  font-size: px2rem(26px);
  color: $orange;
}

.icon-mobile {
  background: url(../../../assets/img/phone_number_correct.png) no-repeat;
  background-size: contain;
  border-radius: px2rem(30px);
  position: absolute;
  top: px2rem(70px);
  right: px2rem(120px);
  display: inline-block;
  width: px2rem(120px);
  height: px2rem(30px);
  line-height: px2rem(30px);
}

.checkCode-right {
  background: url(../../../assets/img/correct_right.png);
  background-size: contain;
  border-radius: px2rem(30px);
  position: absolute;
  top: px2rem(70px);
  right: px2rem(232px);
  display: inline-block;
  width: px2rem(30px);
  height: px2rem(30px);
  line-height: px2rem(30px);
}

.disabled {
  border: 1px solid #e3e3e4;
  color: #cccccc;
  width: px2rem(170px);
}
</style>



// WEBPACK FOOTER //
// loginCaptcha.vue?9a90275e